import React from 'react';

import config from 'config';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import BaseProductCallout from '~/shared/components/ProductCallout';
import useProductCallout, { Callout } from '~/shared/utils/useProductCallout';
import { useProductContext } from '~/techstyle-shared/react-components';

// list of specified & prioritized options passed to useProductCallout to dictate the types returned
const flytPdpPriorityList = [
  Callout.SOLD_OUT_KEEP_ON_GRID,
  Callout.LAST_CHANCE,
  Callout.YITTY_COLLECTION,
  Callout.DELAYED_SHIPPING,
  Callout.EU_EXCLUSIVE,
  Callout.KHLOES_PICK,
  Callout.PLATINUM_EXCLUSIVE,
  Callout.KATES_EDIT,
  Callout.ECO_STYLE,
  Callout.BACK_IN_STOCK,
  Callout.GOLD_ELITE_EXCLUSIVE,
  Callout.NEW,
];

// STYLED COMPONENTS
const CalloutWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  ${({ theme }) => theme.productDetailMarketingCallout.calloutWrapper}
`;

const ProductCallout = styled(BaseProductCallout)`
  background-color: ${({ theme, type }) =>
    type === 'YITTY_COLLECTION'
      ? theme.colors.pdpCalloutYittyCollection
      : theme.colors.pdpCalloutBg};
  color: ${({ theme, type }) =>
    type === 'YITTY_COLLECTION'
      ? theme.colors.textLight
      : theme.colors.pdpCalloutText};
  text-transform: uppercase;

  ${({ theme }) => theme.productDetailMarketingCallout.productCallout}
`;

const ProductDetailMarketingCallout = ({
  product: productFromProps,
  ...props
}) => {
  const productFromContext = useProductContext();
  const product = productFromProps || productFromContext;

  const useFlytPdpCalloutPriority = config.get(
    'public.brand.features.useFlytPdpCalloutPriority'
  );

  const params = {
    product,
  };

  if (useFlytPdpCalloutPriority) {
    params.callouts = flytPdpPriorityList;
  }

  const callout = useProductCallout(params);

  return (
    callout && (
      <CalloutWrapper data-autotag="pdp-marketing-callout" {...props}>
        <ProductCallout type={callout.type} value={callout.value} />
      </CalloutWrapper>
    )
  );
};

ProductDetailMarketingCallout.propTypes = {
  product: PropTypes.object,
};

export default ProductDetailMarketingCallout;
